import {
  type FieldType,
  PostCardMediaFragmentFragment,
} from '@/__generated__/graphql';
import { PredictionTournamentPostField } from '@/components/tournament-post-card/prediction-tournament-post-field.tsx';
import { PostCardMedia } from '../post-card/post-card-media/post-card-media';
import { TextEditor } from '../text-editor/text-editor';
import { postCardBody } from '../post-card/post-card.css';

export const TournamentPostField = ({
  name,
  type,
  value,
  authorId,
  index,
}: {
  name: string;
  type: FieldType;
  value?: string;
  authorId: string;
  index?: number;
}) => {
  switch (type) {
    case 'RICH_TEXT':
      return (
        <TextEditor
          namespace={`tournament-post:${name}`}
          className={postCardBody}
          initialState={value}
          editable={false}
          withShowMore
          charLimit={330}
        />
      );
    case 'PERCENTAGE':
      if (index === undefined || !value) return null;

      return (
        <PredictionTournamentPostField
          name={name}
          value={value}
          index={index + 1}
        />
      );
    case 'MEDIA':
      return (
        <PostCardMedia
          media={
            value
              ? (JSON.parse(value) as PostCardMediaFragmentFragment[])
              : undefined
          }
          authorId={authorId}
        />
      );
    default:
      return null;
  }
};
